import styled from 'styled-components';
import { media } from '../../theme';

export const Wrapper = styled.div`
    width: 100%;
    max-width: 900px;
    margin: 0 auto;
    padding: 16px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
    color: #222;
    line-height: 1.6;

    ${media.sm} {
        padding: 20px;
    }

    ${media.md} {
        padding: 24px;
    }

    h1 {
        font-size: 24px;
        line-height: 32px;
        margin-top: 1.2em;

        ${media.sm} {
            font-size: 28px;
            line-height: 36px;
        }

        ${media.md} {
            font-size: 32px;
            line-height: 40px;
        }
    }

    h2 {
        font-size: 20px;
        line-height: 28px;
        margin-top: 1.2em;

        ${media.sm} {
            font-size: 22px;
            line-height: 30px;
        }

        ${media.md} {
            font-size: 24px;
            line-height: 32px;
        }
    }

    h3 {
        font-size: 18px;
        line-height: 26px;
        margin-top: 1.2em;

        ${media.sm} {
            font-size: 19px;
            line-height: 27px;
        }

        ${media.md} {
            font-size: 20px;
            line-height: 28px;
        }
    }

    h4, h5, h6 {
        font-size: 16px;
        line-height: 24px;
        margin-top: 1.2em;

        ${media.md} {
            font-size: 18px;
            line-height: 26px;
        }
    }

    p {
        font-size: 14px;
        line-height: 22px;
        margin: 0.8em 0;

        ${media.md} {
            font-size: 16px;
            line-height: 24px;
        }
    }

    pre {
        background: #f7f7f7;
        padding: 12px;
        border-radius: 6px;
        overflow: auto;
        font-size: 13px;

        ${media.md} {
            font-size: 14px;
        }
    }

    code {
        background: #f7f7f7;
        padding: 2px 4px;
        border-radius: 4px;
        font-size: 13px;

        ${media.md} {
            font-size: 14px;
        }
    }

    a {
        color: #1976d2;
        text-decoration: none;
        word-break: break-word;
    }

    a:hover {
        text-decoration: underline;
    }

    img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
        display: block;
        margin: 16px auto;

        ${media.md} {
            margin: 20px auto;
        }
    }

    ul, ol {
        padding-left: 20px;
        margin: 0.8em 0;

        ${media.md} {
            padding-left: 24px;
        }
    }

    li {
        font-size: 14px;
        line-height: 22px;
        margin: 0.4em 0;

        ${media.md} {
            font-size: 16px;
            line-height: 24px;
        }
    }

    table {
        width: 100%;
        border-collapse: collapse;
        margin: 1em 0;
        font-size: 14px;
        overflow-x: auto;
        display: block;

        ${media.md} {
            font-size: 16px;
            display: table;
        }
    }

    th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;

        ${media.md} {
            padding: 12px;
        }
    }

    th {
        background-color: #f7f7f7;
        font-weight: 600;
    }

    blockquote {
        border-left: 4px solid #ddd;
        margin: 1em 0;
        padding: 8px 12px;
        background: #f9f9f9;
        font-size: 14px;

        ${media.md} {
            padding: 12px 16px;
            font-size: 16px;
        }
    }
`;

export const TopBar = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-bottom: 12px;

    ${media.sm} {
        margin-bottom: 14px;
    }

    ${media.md} {
        margin-bottom: 16px;
    }
`;
